export default __webpack_public_path__ + "static/media/logo-white.b3cf217d.svg";